import { createTheme } from '@material-ui/core/styles';

const CustomTheme = createTheme({
    direction: 'rtl',
    fontFamily:'IRANSans',
    typography:{
        fontFamily: ['IRANSans'].join(','),
        allVariants: {
            fontFamily: 'IRANSans'
        }
    },
    bottomTab: {
        fontFamily: 'IRANSans'
    },
});

export default CustomTheme
